module.exports = __webpack_public_path__ + "static/media/call-made.6ec84600.svg";